(() => {
  const ready = () => {
    const root = document.documentElement;
    const isEnglish = (root.lang || '').toLowerCase().startsWith('en');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const archiveRoot = document.querySelector('.ra');
    if (archiveRoot) root.classList.add('ra-page');

    if (archiveRoot && isEnglish) {
      if (archiveRoot.classList.contains('ra-market')) document.title = 'REVIVE ARCHIVE – REVIVE SHOP';
      const exactTranslations = new Map([
        ['WATCHES', 'ARCHIVE'],
        ['MUJER', 'WOMEN'],
        ['TIENDA', 'SHOP'],
        ['REVIVE EN ALICANTE', 'REVIVE IN ALICANTE'],
        ['Nuestro espacio físico de second hand seleccionado en el centro de Alicante.', 'Our selected second-hand space in the centre of Alicante.'],
        ['CÓMO LLEGAR', 'GET DIRECTIONS'],
        ['Síguenos', 'Follow us'],
        ['ENVÍO GRATIS EN ESPAÑA A PARTIR DE 40€', 'FREE SHIPPING IN SPAIN ON ORDERS OVER €40']
      ]);
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      let textNode;
      while ((textNode = walker.nextNode())) {
        const source = textNode.nodeValue.trim();
        if (exactTranslations.has(source)) textNode.nodeValue = textNode.nodeValue.replace(source, exactTranslations.get(source));
      }
    }

    if (archiveRoot) {
      let scrollFrame = 0;
      const updateArchiveScroll = () => {
        scrollFrame = 0;
        const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        archiveRoot.style.setProperty('--ra-scroll', Math.max(0, Math.min(1, window.scrollY / maxScroll)).toFixed(4));
      };
      window.addEventListener('scroll', () => {
        if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateArchiveScroll);
      }, { passive: true });
      window.addEventListener('resize', updateArchiveScroll, { passive: true });
      updateArchiveScroll();
    }

    document.querySelectorAll('[data-revive-archive]').forEach((archive) => {
      const gate = archive.querySelector('[data-ra-gate]');
      if (!gate) return;

      if (window.location.hash === '#archivo-market') {
        gate.remove();
        root.classList.remove('ra-gate-active');
        return;
      }

      root.classList.add('ra-gate-active');
      const mobileUnlock = window.matchMedia('(max-width: 749px)').matches;
      const openGate = () => {
        if (gate.classList.contains('is-open')) return;
        gate.classList.add('is-open');
        gate.setAttribute('aria-hidden', 'true');
        root.classList.remove('ra-gate-active');
        window.setTimeout(() => gate.remove(), reducedMotion ? 20 : 900);
      };

      if (!mobileUnlock) {
        archive.querySelectorAll('[data-ra-enter]').forEach((button) => {
          button.addEventListener('click', openGate);
        });
      }

      const slider = archive.querySelector('[data-ra-slider]');
      if (mobileUnlock && slider) {
        let dragging = false;
        let startX = 0;
        let progress = 0;

        const maxTravel = () => Math.max(1, slider.clientWidth - 78);
        const setProgress = (next) => {
          progress = Math.max(0, Math.min(1, next));
          slider.style.setProperty('--ra-unlock-x', `${progress * maxTravel()}px`);
          slider.style.setProperty('--ra-unlock-progress', progress.toFixed(3));
          slider.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
        };
        const resetSlider = () => {
          dragging = false;
          slider.classList.remove('is-dragging');
          setProgress(0);
        };
        const finishSlider = () => {
          dragging = false;
          slider.classList.remove('is-dragging');
          if (progress >= 0.82) {
            setProgress(1);
            slider.classList.add('is-complete');
            window.setTimeout(openGate, reducedMotion ? 0 : 130);
          } else {
            resetSlider();
          }
        };

        slider.addEventListener('pointerdown', (event) => {
          if (event.button !== undefined && event.button !== 0) return;
          dragging = true;
          startX = event.clientX - (progress * maxTravel());
          slider.classList.add('is-dragging');
          slider.setPointerCapture?.(event.pointerId);
          event.preventDefault();
        });
        slider.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          setProgress((event.clientX - startX) / maxTravel());
          event.preventDefault();
        });
        slider.addEventListener('pointerup', finishSlider);
        slider.addEventListener('pointercancel', resetSlider);
        slider.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            setProgress(progress + 0.12);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setProgress(progress - 0.12);
          } else if (event.key === 'Home') {
            event.preventDefault();
            setProgress(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            setProgress(1);
            finishSlider();
          } else if ((event.key === 'Enter' || event.key === ' ') && progress >= 0.82) {
            event.preventDefault();
            finishSlider();
          }
        });
        window.addEventListener('resize', () => setProgress(progress), { passive: true });
        setProgress(0);
      }

      if (mobileUnlock) {
        const swipeHint = archive.querySelector('.ra-gate__slider-label');
        const swipeControl = archive.querySelector('[data-ra-slider]');
        if (swipeHint) swipeHint.textContent = isEnglish ? 'SWIPE UP ↑' : 'DESLIZA HACIA ARRIBA ↑';
        if (swipeControl) {
          swipeControl.setAttribute('role', 'note');
          swipeControl.setAttribute('aria-label', isEnglish ? 'Swipe up anywhere on the screen to enter the market' : 'Desliza hacia arriba en cualquier parte de la pantalla para entrar al market');
          swipeControl.removeAttribute('aria-valuemin');
          swipeControl.removeAttribute('aria-valuemax');
          swipeControl.removeAttribute('aria-valuenow');
          swipeControl.removeAttribute('tabindex');
        }

        archive.querySelectorAll('[data-ra-enter]').forEach((button) => {
          button.addEventListener('click', openGate);
        });

        let touchStartX = 0;
        let touchStartY = 0;
        let pullDistance = 0;
        let trackingPull = false;
        let verticalIntent = false;

        const resetPull = () => {
          trackingPull = false;
          verticalIntent = false;
          pullDistance = 0;
          gate.classList.remove('is-pulling');
          gate.style.removeProperty('--ra-pull-y');
        };

        gate.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          pullDistance = 0;
          trackingPull = true;
          verticalIntent = false;
          gate.classList.add('is-pulling');
        }, { passive: true });

        gate.addEventListener('touchmove', (event) => {
          if (!trackingPull || event.touches.length !== 1) return;
          const deltaX = event.touches[0].clientX - touchStartX;
          const deltaY = event.touches[0].clientY - touchStartY;

          if (!verticalIntent && Math.abs(deltaY) > 10) {
            verticalIntent = deltaY < 0 && Math.abs(deltaY) > Math.abs(deltaX) * 1.1;
          }
          if (!verticalIntent) return;

          pullDistance = Math.max(0, Math.min(150, -deltaY));
          gate.style.setProperty('--ra-pull-y', `${pullDistance * -.32}px`);
          if (event.cancelable) event.preventDefault();
        }, { passive: false });

        gate.addEventListener('touchend', () => {
          if (verticalIntent && pullDistance >= 72) {
            gate.classList.remove('is-pulling');
            gate.style.removeProperty('--ra-pull-y');
            openGate();
          } else {
            resetPull();
          }
        }, { passive: true });

        gate.addEventListener('touchcancel', resetPull, { passive: true });
      }
    });

    const revealItems = [...document.querySelectorAll('[data-ra-card], .ra-dossier__top, .ra-gallery, .ra-story')];
    revealItems.forEach((item, index) => {
      item.classList.add('ra-reveal');
      item.style.setProperty('--ra-delay', `${Math.min(index % 4, 3) * 70}ms`);
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealItems.forEach((item) => observer.observe(item));
    }

    if (!reducedMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.querySelectorAll('[data-ra-tilt]').forEach((visual) => {
        let frame = 0;
        let latestEvent = null;

        const renderTilt = () => {
          frame = 0;
          if (!latestEvent) return;
          const bounds = visual.getBoundingClientRect();
          const px = Math.max(0, Math.min(1, (latestEvent.clientX - bounds.left) / bounds.width));
          const py = Math.max(0, Math.min(1, (latestEvent.clientY - bounds.top) / bounds.height));
          visual.style.setProperty('--ra-rx', `${(0.5 - py) * 11}deg`);
          visual.style.setProperty('--ra-ry', `${(px - 0.5) * 13}deg`);
          visual.style.setProperty('--ra-mx', `${px * 100}%`);
          visual.style.setProperty('--ra-my', `${py * 100}%`);
        };

        visual.addEventListener('pointerenter', () => visual.classList.add('is-tracking'), { passive: true });
        visual.addEventListener('pointermove', (event) => {
          latestEvent = event;
          if (!frame) frame = window.requestAnimationFrame(renderTilt);
        }, { passive: true });
        visual.addEventListener('pointerleave', () => {
          latestEvent = null;
          if (frame) window.cancelAnimationFrame(frame);
          frame = 0;
          visual.classList.remove('is-tracking');
          visual.style.setProperty('--ra-rx', '0deg');
          visual.style.setProperty('--ra-ry', '0deg');
          visual.style.setProperty('--ra-mx', '50%');
          visual.style.setProperty('--ra-my', '50%');
        }, { passive: true });
      });
    }

    document.querySelectorAll('[data-ra-card-gallery]').forEach((gallery) => {
      const images = [...gallery.querySelectorAll('[data-ra-card-image]')];
      const previous = gallery.querySelector('[data-ra-card-prev]');
      const next = gallery.querySelector('[data-ra-card-next]');
      const current = gallery.querySelector('[data-ra-card-current]');
      if (images.length < 2) return;
      let active = Math.max(0, images.findIndex((image) => image.classList.contains('is-active')));

      const showCardImage = (requested) => {
        active = (requested + images.length) % images.length;
        images.forEach((image, index) => image.classList.toggle('is-active', index === active));
        if (current) current.textContent = String(active + 1).padStart(2, '0');
      };
      previous?.addEventListener('click', () => showCardImage(active - 1));
      next?.addEventListener('click', () => showCardImage(active + 1));

      const visual = gallery.querySelector('.ra-card__visual');
      if (visual) {
        let touchX = 0;
        visual.addEventListener('touchstart', (event) => {
          if (event.touches.length === 1) touchX = event.touches[0].clientX;
        }, { passive: true });
        visual.addEventListener('touchend', (event) => {
          const end = event.changedTouches?.[0]?.clientX;
          if (typeof end !== 'number') return;
          const distance = end - touchX;
          if (Math.abs(distance) < 44) return;
          event.preventDefault();
          showCardImage(active + (distance < 0 ? 1 : -1));
        }, { passive: false });
      }
    });

    document.querySelectorAll('[data-ra-dossier]').forEach((dossier) => {
      const thumbs = [...dossier.querySelectorAll('[data-ra-thumb]')];
      const views = [...dossier.querySelectorAll('[data-ra-view]')];
      const stage = dossier.querySelector('[data-ra-swipe-stage]');
      let activeIndex = Math.max(0, views.findIndex((view) => view.classList.contains('is-active')));

      const activateView = (requestedIndex) => {
        if (!views.length) return;
        activeIndex = (requestedIndex + views.length) % views.length;
        thumbs.forEach((item, index) => {
          const active = index === activeIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        views.forEach((view, index) => view.classList.toggle('is-active', index === activeIndex));
        if (stage) {
          stage.classList.remove('is-swiping');
          stage.style.setProperty('--ra-swipe-x', '0px');
        }
      };

      thumbs.forEach((thumb, index) => {
        thumb.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
        thumb.addEventListener('click', () => activateView(index));
      });

      if (stage && views.length > 1) {
        let startX = 0;
        let startY = 0;
        let deltaX = 0;
        let horizontalGesture = false;

        const resetSwipe = () => {
          horizontalGesture = false;
          deltaX = 0;
          stage.classList.remove('is-swiping');
          stage.style.setProperty('--ra-swipe-x', '0px');
        };

        stage.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          deltaX = 0;
          horizontalGesture = false;
        }, { passive: true });

        stage.addEventListener('touchmove', (event) => {
          if (event.touches.length !== 1) return;
          const dx = event.touches[0].clientX - startX;
          const dy = event.touches[0].clientY - startY;
          if (!horizontalGesture && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) + 4) horizontalGesture = true;
          if (!horizontalGesture) return;
          event.preventDefault();
          deltaX = dx;
          stage.classList.add('is-swiping');
          stage.style.setProperty('--ra-swipe-x', `${Math.max(-100, Math.min(100, dx * 0.62))}px`);
        }, { passive: false });

        stage.addEventListener('touchend', () => {
          if (horizontalGesture && Math.abs(deltaX) > 46) {
            activateView(activeIndex + (deltaX < 0 ? 1 : -1));
          } else {
            resetSwipe();
          }
        }, { passive: true });

        stage.addEventListener('touchcancel', resetSwipe, { passive: true });
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
